<script lang="ts">
export type IconName =
  | 'health'
  | 'tooth'
  | 'glasses'
  | 'house'
  | 'key'
  | 'shield'
  | 'plane'
  | 'globe'
  | 'suitcase'
  | 'umbrella'
  | 'heart'
  | 'mapPin'
  | 'chevron'
</script>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    name: IconName
    size?: number | string
  }>(),
  { size: 24 },
)

const paths: Record<IconName, string> = {
  health:   'M12 4v16M4 12h16',
  tooth:    'M8 3.2c-2 0-3.3 1.7-3.3 4 0 1.3.3 2.5.7 3.8.5 1.6.6 4.2 1.2 7 .3 1.4 1 2 1.7 2 1 0 1.3-.8 1.7-2.5l.7-3c.2-.8 1-.8 1.2 0l.7 3c.4 1.7.7 2.5 1.7 2.5.7 0 1.4-.6 1.7-2 .6-2.8.7-5.4 1.2-7 .4-1.3.7-2.5.7-3.8 0-2.3-1.3-4-3.3-4-1.2 0-2 .5-2.5 1h-2c-.5-.5-1.3-1-2.5-1z',
  glasses:  'M3 14a3 3 0 1 0 6 0 3 3 0 0 0-6 0zM15 14a3 3 0 1 0 6 0 3 3 0 0 0-6 0zM9 14h6M2 10l2-3M22 10l-2-3',
  house:    'M3 11l9-8 9 8M5 10v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10M10 21v-6h4v6',
  key:      'M14 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm-4 4H3v3M7 12v2',
  shield:   'M12 3l8 3v5c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-3z',
  plane:    'M2 16.5l9-3v-7c0-1 .5-2 1-2s1 1 1 2v7l9 3v2l-9-2.5V21l3 2v1l-4-1.5L7 24v-1l3-2v-4.5L2 18.5v-2z',
  globe:    'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM2 12h20M12 2c-3 3-3 17 0 20M12 2c3 3 3 17 0 20',
  suitcase: 'M4 8h16v13H4zM9 8V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3M4 14h16',
  umbrella: 'M12 3v18M3 12a9 9 0 0 1 18 0c-1-1-2.5-1.5-3.5-1.5S15 11 14 12s-1-1.5-2-1.5-1 .5-2 1.5-1-1.5-2-1.5-1.5.5-2.5 1.5S4 11 3 12zM12 21a3 3 0 0 0 3-3',
  heart:    'M12 21s-7-4.5-9-9.5C1.7 7.7 4 4 7.5 4c1.8 0 3.4 1 4.5 2.5C13.1 5 14.7 4 16.5 4 20 4 22.3 7.7 21 11.5 19 16.5 12 21 12 21z',
  mapPin:   'M12 22s-7-7-7-12a7 7 0 1 1 14 0c0 5-7 12-7 12zM12 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6z',
  chevron:  'M6 9l6 6 6-6',
}
</script>

<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path :d="paths[props.name]" />
  </svg>
</template>
